import { Routes } from '@angular/router';
import { IsConnectedGuard } from './core/guards/is-connected.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login-routing').then((m) => m.routes),
  },
  {
    path: 'confirm-email',
    loadChildren: () =>
      import('./modules/confirm-email/confirm-email-routing').then(
        (m) => m.routes
      ),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./modules/forgot-password/forgot-password-routing').then(
        (m) => m.routes
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./modules/reset-password/reset-password-routing').then(
        (m) => m.routes
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/dashboard/dashboard-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'bots',
    loadChildren: () =>
      import('./modules/bot/bot-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./modules/campaign/campaign-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'incidents',
    loadChildren: () =>
      import('./modules/incident/incident-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'analyses',
    loadChildren: () =>
      import('./modules/analysis/analysis-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'scheduler',
    loadChildren: () =>
      import('./modules/scheduler/scheduler-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./modules/settings/settings-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'secrets',
    redirectTo: 'variables',
    pathMatch: 'prefix',
  },
  {
    path: 'variables',
    loadChildren: () =>
      import('./modules/variables/variables-routing').then((m) => m.routes),
    canActivate: [IsConnectedGuard],
  },
  {
    path: 'invitation',
    loadChildren: () =>
      import('./modules/link-to-compagny/link-to-compagny-routing').then(
        (m) => m.routes
      ),
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./modules/company/company-routing').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
